import React, { useState, useEffect } from 'react';
import { FiGithub, FiLinkedin} from 'react-icons/fi';

const Footer = () => {
  const [time, setTime] = useState('');

  useEffect(() => {
    // Set up an interval to update the time every second
    const timerId = setInterval(() => {
      const currentTime = new Date().toLocaleTimeString('en-IN', {
        timeZone: 'Asia/Kolkata',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
      setTime(currentTime);
    }, 1000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(timerId);
  }, []);

  const year = new Date().getFullYear();

  return (
    <footer className="bg-black grainy text-sm text-text-secondary border-t border-white/10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto h-20 flex justify-between items-center">
        {/* Left: Copyright */}
        <div>
          <p>&copy; {year} Dheeraj Reddy</p>
        </div>

        {/* Center: Status Bar (hidden on mobile) */}
        <div className="hidden md:flex items-center gap-6 font-mono">
          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
            <span>Available for opportunities</span>
          </div>
          <span>📍 Hyderabad, India</span>
          <span>🕒 {time} IST</span>
        </div>

        {/* Right: Social Links */}
        <div className="flex items-center gap-6 text-lg">
          <a href="https://github.com/YadamDheerajReddy" className="hover:text-accent transition-colors" target='_blank' rel='noreferrer'><FiGithub /></a>
          <a href="https://www.linkedin.com/in/ydheeraj/" className="hover:text-accent transition-colors" target='_blank' rel='noreferrer'><FiLinkedin /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;